<template>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="p-4">
      <el-row>
        <el-button type="text" :disabled="rows.length === 0" :loading="exportBtnLoading" @click="handleExport">
          <i class="bi bi-box-arrow-in-left text-base" />导出Excel
        </el-button>
      </el-row>
      <el-form>
        <el-form-item label="地区:">
          {{ user.area }}
        </el-form-item>

        <el-form-item label="填报月份:" prop="date">
          <el-date-picker
            v-model="deptForm.date"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择填报月份"
            :picker-options="endDateOpt"
          />
        </el-form-item>
        <div class="relative shadow-md sm:rounded-lg">
          <table class="border-collapse border border-slate-400 text-sm text-center dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr v-for="row in [2,3,4,5]" :key="row">
                <template v-if="row === 2">
                  <template v-if="user.role === 'province'">
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4" />
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">市州</th>
                  </template>
                  <template v-else>
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">区</th>
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">公司</th>
                  </template>
                </template>

                <template
                  v-for="(item, index) in hData['row' + row]"
                >
                  <th
                    :key="`${row}_${index}`" class="py-1 px-2 align-center border border-slate-300 whitespace-nowrap"
                    :colspan="item.colspan ? item.colspan : 1"
                    :rowspan="item.rowspan ? item.rowspan : 1"
                  >
                    {{ item.name }}
                  </th>
                </template>
                <template v-if="row === 2">
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">操作</th>
                </template>
              </tr>
            </thead>
            <template v-if="rows.length > 0">
              <template v-for="(row, row_index) in rows">
                <tr v-for="(item, index) in row.items" :key="`${row_index}_${index}`">
                  <th
                    v-if="index === 0" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                    :rowspan="row.items.length"
                  >
                    <a>{{ row.name }}</a>
                  </th>
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap">
                    <template v-if="user.role === 'province'">
                      <el-button type="text" @click="openDetailDialog(item.user_id)">{{ item.name }}</el-button>
                    </template>
                    <template v-else>{{ item.name }}</template>
                  </th>
                  <template
                    v-for="(data_item, data_index) in row_keys"
                  >
                    <th
                      :key="`${index}_${data_index}`" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                    >
                      {{ item[data_item] }}
                    </th>
                  </template>
                  <th v-if="item.id" class="py-1 px-2 border border-slate-300 whitespace-nowrap">
                    <template v-if="user.role === 'province'">
                      <el-button type="text" @click="handleRejectToCompany(item.id, item.city)">退回</el-button>
                    </template>
                    <template v-else>
                      <el-button type="text" @click="handleReject(item.id)">退回</el-button>
                    </template>
                  </th>
                  <th
                    v-if="row.id && index === 0" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                    :rowspan="row.items.length"
                  >
                    <el-button type="text" @click="handleReject(row.id)">退回</el-button>
                  </th>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <th colspan="64" class="py-1 px-2 text-left">暂无数据</th>
              </tr>
            </template>
          </table>
        </div>
        <el-form-item v-if="user.role !== 'province'" class="mt-4">
          <el-button
            type="primary" :loading="loading" :disabled="rows.length === 0 || deptDataStatus === 3"
            @click="onDeptSubmit"
          >
            <template v-if="deptDataStatus === -1 || deptDataStatus === 1 || deptDataStatus === 2">
              上报
            </template>
            <template v-else-if="deptDataStatus === 0">
              更新
            </template>
            <template v-else-if="deptDataStatus === 3">
              已确认
            </template>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog v-loading="detailLoading" :visible.sync="visible" :close-on-click-modal="false" width="100%">
      <el-button type="primary" class="!mb-2" size="small" @click="handleExport2">导出</el-button>
      <div class="relative shadow-md sm:rounded-lg overflow-x-auto">
        <table class="border-collapse border border-slate-400 text-sm text-center dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr v-for="row in [2,3,4,5]" :key="row">
              <template v-if="row === 2">
                <template v-if="user.role === 'province'">
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4" />
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">市州</th>
                </template>
                <template v-else>
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">区</th>
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">公司</th>
                </template>
              </template>

              <template
                v-for="(item, index) in hData['row' + row]"
              >
                <th
                  :key="`${row}_${index}`" class="py-1 px-2 align-center border border-slate-300 whitespace-nowrap"
                  :colspan="item.colspan ? item.colspan : 1"
                  :rowspan="item.rowspan ? item.rowspan : 1"
                >
                  {{ item.name }}
                </th>
              </template>
            </tr>
          </thead>
          <template v-if="detailRows.length > 0">
            <template v-for="(row, row_index) in detailRows">
              <tr v-for="(item, index) in row.items" :key="`${row_index}_${index}`">
                <th
                  v-if="index === 0" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                  :rowspan="row.items.length"
                >
                  {{ row.name }}
                </th>
                <th class="py-1 px-2 border border-slate-300 whitespace-nowrap">
                  {{ item.name }}
                </th>
                <template
                  v-for="(data_item, data_index) in row_keys"
                >
                  <th
                    :key="`${index}_${data_index}`" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                  >
                    {{ item[data_item] }}
                  </th>
                </template>
              </tr>
            </template>
          </template>
          <template v-else>
            <tr>
              <th colspan="64" class="py-1 px-2 text-left">暂无数据</th>
            </tr>
          </template>
        </table>
      </div>
    </el-dialog>
    <el-dialog v-loading="detailLoading" :visible.sync="rejectVisible" :close-on-click-modal="false">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="退回到:">
          <el-cascader
            :show-all-levels="false"
            style="width: 300px;"
            :options="options"
            :props="{}"
            clearable
            v-model="query.area"
          />
        </el-form-item>
        <el-form-item label-position="left" label-width="100px">
          <el-button type="primary" @click="submitReject">退回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Layout2 from '../../Shared/Layout2'
import {areas, getLastMonth, hData, row_keys} from '../../utils'

export default {
  layout: Layout2,
  middleware: ['auth'],
  metaInfo() {
    return {title: '数据填报'}
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    companies: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      areas,
      city: '',
      visible: false,
      detailLoading: false,
      exportBtnLoading: false,
      deptDataStatus: -1, //部门当前选择月填报状态，默认未填报
      rows: [],
      detailRows: [],
      loading: false,
      hData,
      row_keys,
      rules: {
        date: [{required: true, message: '请输入填报月份', trigger: 'blur'}],
      },
      endDateOpt: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      deptForm: {},
      rejectVisible: false,
      options: [],
      query: {
        id: 0,
        area: []
      },
    }
  },
  watch: {
    'deptForm.date': function (newVal, oldVal) {
      if (!newVal) {
        return
      }
      // console.log('deptForm.date changed', newVal, oldVal)
      this.loadDeptData()
    },
  }, mounted() {
    console.log(this.user)

    this.deptForm = {
      id: this.user.id,
      date: getLastMonth(),
    }
    // console.log(this.rules)
    // this.tableData.forEach(ele => {
    //   ele.rowspan = 1
    // })
    // this.tableData = this.tableData
    // for (let i = 0; i < this.tableData.length; i++) {
    //   for (let j = i + 1; j < this.tableData.length; j++) {
    //     console.log(this.tableData[i].Statistics)
    //     if (this.tableData[i].Statistics == this.tableData[j].Statistics) {
    //       this.tableData[i].rowspan++
    //       this.tableData[j].rowspan--
    //     }
    //   }
    //   // 这里跳过已经重复的数据
    //   i = i + this.tableData[i].rowspan - 1
    // }
  },
  methods: {
    submitReject() {
      // console.log(this.query)
      this.handleReject(this.query.id, this.query.area)
    },
    getOptions(city) {
      console.log(this.areas, city)
      let area = this.areas.find(item => item.value === city)
      var children = []
      for (let district_index in area.children) {
        const district = area.children[district_index]

        children.push({value: district.value, label: district.label, children: (area.value in this.companies && district.value in this.companies[area.value])  ? this.companies[area.value][district.value] : []})
      }
      // this.options = [{
      //   value: 'hn',
      //   label: '全省',
      //   children: _areas
      // }]
      return children
    },
    openDetailDialog(city) {
      console.log(city)
      this.visible = true
      this.city = city
      this.detailLoading = true
      axios.get('/dept/data', {params: {id: city, date: this.deptForm.date}}).then((res) => {
        this.detailLoading = false
        if (res.data.status === 1) {
          this.detailRows = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleRejectToCompany(id, city) {
      this.rejectVisible = true
      this.query = {
        id: id,
        area: []
      }
      this.options = this.getOptions(city)
    },
    handleReject(id, area) {
      this.$confirm('确认退回该上报数据？')
        .then(_ => {
          axios.post('/company/reject', {id: id, area: area}).then((res) => {
            if (res.data.status === 1) {
              this.$message.success('退回成功')
              this.loadDeptData()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
          })
        })
        .catch(_ => {
        })
    },
    onDeptSubmit() {
      this.loading = true
      axios.post('/dept', this.deptForm).then((res) => {
        if (res.data.status === 1) {
          this.$message.success('上报成功')
        } else {
          this.$message.error(res.data.message)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    loadDeptData() {
      axios.get('/dept/data', {params: {id: this.deptForm.id, date: this.deptForm.date}}).then((res) => {
        if (res.data.status === 1) {
          this.deptDataStatus = res.data.data_status
          this.rows = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleExport() {
      this.exportBtnLoading = true
      axios.get('/dept/export', {params: {dept_id: this.deptForm.id, date: this.deptForm.date}}).then((res) => {
        this.exportBtnLoading = false
        if (res.data.status === 1) {
          window.open(res.data.url)
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleExport2() {
      this.exportBtnLoading = true
      axios.get('/dept/export', {params: {dept_id: this.city, date: this.deptForm.date}}).then((res) => {
        this.exportBtnLoading = false
        if (res.data.status === 1) {
          window.open(res.data.url)
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
